import { groupBy } from 'lodash'
import IntervalMap from '@/models/classe.js';

class Item {
  constructor(nom, group, price) {
    this.nom = nom;
    this.group = group;
    this.price = price;
  }
}

const showNoms = (items, sep=",") => items.map(i => i.nom).join(sep)

const Catalogue = [
    new Item("hache", "viande", 0),
    new Item("morue", "viande", 1.2),
    new Item("poulet", "viande", 0),
    new Item("saucisse", "viande", 0),
    new Item("mouton", "viande", 1.2),
    new Item("jambon", "viande", 0),

    new Item("chien", "sauce", 0.5),
    new Item("harissa", "sauce", 0.5),
    new Item("ketchup", "sauce", 0.5),
    new Item("mayo", "sauce", 0.4),
    new Item("barbecue", "sauce", 0.5),
    new Item("biggie", "sauce", 0.5),
    new Item("samurai", "sauce", 0.5),
    new Item("algerienne", "sauce", 0.5),

    new Item("coca", "boisson", 1),
    new Item("oasis", "boisson", 1),
    new Item("fanta", "boisson", 1),
    new Item("fanta exo", "boisson", 1),
    new Item("lipton", "boisson", 1),
    new Item("perrier", "boisson", 1),
    new Item("cristalline", "boisson", 1),
    new Item("kola campagne", "boisson", 1),

    new Item("nature", "pain", 0),
    new Item("emmental", "pain", 0.5),

    new Item("salade", "condiment", 0),
    new Item("tomate", "condiment", 0),
    new Item("oignon", "condiment", 0),
    new Item("olive",  "condiment", 0),

    new Item("avocat", "legume", 0.6),
    new Item("poivron", "legume", 0.4),
    new Item("carotte", "legume", 0.4),
    new Item("concombre", "legume", 0.4),
    new Item("champignon", "legume", 0.4),

    new Item("chevre",  "fromage", 0.6),
    new Item("cheddar", "fromage", 0.6),
    new Item("boursin", "fromage", 0.6),
    new Item("raclette", "fromage", 0.6),
    new Item("emmental", "fromage", 0.6),

    new Item("oeufs", "bobo", 0.9),
    new Item("lardon", "bobo", 0.9),
    new Item("bacon", "bobo", 0.9),
    new Item("knacki", "bobo", 0.9),
    new Item("crevette", "bobo", 1.2)
];

let { viande, sauce, pain, condiment, legume, fromage, bobo, boisson } =
    groupBy(Catalogue, i => i.group);

const Classes = new IntervalMap(
    { nom: "vide", prix: 0 },
    {
        1: { nom: "modeste", prix: 5 },
        2: { nom: "titan", prix: 7 },
        3: { nom: "imperial", prix: 9 },
    },
    { nom: "ultra", prix: 12 },
);

const Societe = {
  nom: "lebobo",
  slogan: "aux grandes faims les grands bobos",
  description: "livraison de bokits",
  siret: "453 901 159 00021",
  tel: "0701020304",
  handle: "@lebobo"
};

const villes = [
  { label: "villepinte", nom: "villepinte" },
  { label: "villeparisis", nom: "villeparisis" },
  { label: "livry-gargan", nom: "livry-gargan" },
  { label: "aulnay-sous-bois", nom: "aulnay-sous-bois" },
  { label: "sevran", nom: "sevran" },
  { label: "vaujours", nom: "vaujours" },
  { label: "coubron", nom: "coubron" },
  { label: "tremblay-en-france", nom: "tremblay-en-france" },
  { label: "roissy-en-france", nom: "roissy-en-france" }
];

export {
  showNoms,
  Catalogue,
  viande,
  sauce,
  pain,
  condiment,
  legume,
  fromage,
  bobo,
  boisson,
  Classes,
  Societe,
  villes
};
